import styled from 'styled-components';

export const DashboardContainer = styled.div`
  width: 100%;
	display: flex;
	flex-direction: column;
  background-color: #F0F2F5;
`;

export const DashboardHeader = styled.div`
  background-color: #008069;
	color: white;
	padding: 16px;
	display: flex;
	align-items: center;
	gap: 16px;
`;

export const DashboardActions = styled.div`
	display: flex;
  width: 100%;
  flex-direction: row;
  padding: 16px;
	gap: 16px;
  justify-content: flex-end;
  align-items: start;
  overflow: visible;
`;

export const DashboardTitle = styled.h2`
	margin: 0;
	font-size: 20px;
	font-weight: 500;
	color: white;
`;

export const DashboardContent = styled.div`
	display: flex;
	flex-direction: column;
  overflow: auto;

  .CardSection {
    display: flex;
    flex-direction: column;
    padding: 16px;
    width: 100%;
    gap: 8px;

    .CardList {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    }

    .Card {
      display: flex;
      flex-direction: row;
      width: 15%;
      padding: 16px 8px;
      border-radius: 16px;
      border: 1px solid #EAEFE9;
      background-color: white;
      gap: 16px;

      .CardTitle {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
      }

      .CardValue {
        font-size: 18px;
        font-weight: 500;
        color: #111B21;
      }
    }
  }

  .NegotiatorSection {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    width: 100%;
    border-radius: 16px;
    border: 1px solid #EAEFE9;
  }
`;


export const NegotiatorTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #EAEFE9;
  background-color: white;

  .SectionTitle {
    font-size: 16px;
    padding: 16px;
    font-weight: 500;
    color: #111B21;
  }
`;


export const TableWrapper = styled.div`
  background: #ffffff;
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  max-width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  font-family: sans-serif;
`;

export const Thead = styled.thead`
  color: #6c757d;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
`;

export const Th = styled.th`
  padding: 12px;
`;

export const Td = styled.td`
  padding: 12px;
  font-size: 14px;
  vertical-align: middle;
`;

export const StatusIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const Dot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.color};
`;

export const Badge = styled.span`
  background-color: ${props => props.color};
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  color: #212529;
`;

export const ChartContainer = styled.div`
  padding: 16px;

  .ChartSection {
    background-color: white;
    border-radius: 16px;
    padding: 16px;
  }
`;